import React from 'react';
import { brandClass, brandLabel, statusLabel, LOCATION_LABELS, JAMES_LABELS, NOAH_LABELS, COLOUR_MAP } from '../helpers';

export function StatusBadge({ value }) {
  return <span className={`sb ${value || 'na'}`}>{statusLabel(value)}</span>;
}

// Brand logos — same assets the Acts app uses on the Detail Queue, plus
// Michel's own mark for USED CARS. SERVICE still falls back to a text chip.
export const BRAND_LOGO = {
  KIA:    `${process.env.PUBLIC_URL}/brand-logos/kia.png`,
  SUZUKI: `${process.env.PUBLIC_URL}/brand-logos/suzuki.png`,
  GWM:    `${process.env.PUBLIC_URL}/brand-logos/gwm.png`,
  GAC:    `${process.env.PUBLIC_URL}/brand-logos/gac.png`,
  USED:   `${process.env.PUBLIC_URL}/brand-logos/used.png`,
};

export function BrandTag({ brand }) {
  const logo = BRAND_LOGO[brand];
  if (logo) return <img className="blogo" src={logo} alt={brand} title={brand} />;
  return <span className={`btg ${brandClass(brand)}`}>{brandLabel(brand)}</span>;
}

export function LocationBadge({ location }) {
  if (!location) return null;
  return <span className={`lbg ${location}`}>{LOCATION_LABELS[location] || location}</span>;
}

export function ColourDot({ colour }) {
  return (
    <>
      <span className="cdot" style={{ background: COLOUR_MAP[colour] || '#ccc' }} />
      {colour || '—'}
    </>
  );
}

export function JamesBadge({ value, onClick }) {
  const cls = ['empty', 'j1', 'j2'][value || 0];
  return (
    <span className={`jnb ${cls}`} onClick={onClick}>
      {JAMES_LABELS[value || 0]}
    </span>
  );
}

export function NoahBadge({ value, onClick }) {
  const cls = ['empty', 'n1', 'n2'][value || 0];
  return (
    <span className={`jnb ${cls}`} onClick={onClick}>
      {NOAH_LABELS[value || 0]}
    </span>
  );
}
